import { render, staticRenderFns } from "./reviewSession.vue?vue&type=template&id=529afa7b&lang=html&"
import script from "./reviewSession.vue?vue&type=script&lang=ts&"
export * from "./reviewSession.vue?vue&type=script&lang=ts&"
import style0 from "./reviewSession.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports